// extracted by mini-css-extract-plugin
export var actions = "_1g-0";
export var actionsContainer = "_1g-7";
export var border = "_1g-1";
export var childFullHeight = "_1g-f";
export var collapse = "_1g-2";
export var content = "_1g-a";
export var contentChild = "_1g-e";
export var fullscreen = "_1g-c";
export var hasLeftRadius = "_1g-k";
export var headerContainer = "_1g-3";
export var headerRow = "_1g-5";
export var hidePadding = "_1g-b";
export var navCollapsedGap = "_1g-l";
export var noScrollX = "_1g-m";
export var noScrollY = "_1g-n";
export var noTopPadding = "_1g-i";
export var optOutTopPadding = "_1g-d";
export var pageMain = "_1g-j";
export var pageOuter = "_1g-g";
export var pagePadding = "_1g-8";
export var pageScroll = "_1g-9";
export var profile = "_1g-o";
export var profileContainer = "_1g-p";
export var profileImage = "_1g-q";
export var profileMain = "_1g-r";
export var profileSubtitle = "_1g-t";
export var profileTitle = "_1g-s";
export var showLeftPadding = "_1g-h";
export var tabsPortalSlot = "_1g-6";
export var tabsWrapper = "_1g-4";
export var title = "_1g-u";